import AppNexusVideoBanner from './AppNexusVideoBanner';

export default AppNexusVideoBanner;
